export const PAGE_NAME = Object.freeze({
  PN_ERR: "/error",
  PN_EXP: "/expired",
  PN_UPR: "/bizline/bizinfo/update",
  PN_UPC: "/bizline/bizinfo/check",
  PN_CPS: "/bizline/checkplus/success",
  PN_CPF: "/bizline/checkplus/fail",
});

export const TXVSUSRDIVCD = Object.freeze({
  TXVS_CRP_BIZR: "10",
  TXVS_PRV_BIZR: "20",
  TXVS_TBZ_ACYPE: "30",
  TXVS_PRV: "40",
});

export const MSG = Object.freeze({
  MSG_LOADING: "조회중...",
});

export const STATUS_MSG = Object.freeze({
  UNREGISTERED: "미등록",
  REGISTERED: "확인완료",
  LOADING: "확인중",
  EXPIRED: "발급일로부터 3개월(90일)이 경과한 발급번호입니다.",
  NOTVALID: "잘못된 발급 번호입니다.",
});

export const ALERT_TYPE = Object.freeze({
  ALERT: "alert",
  CONFIRM: "confirm",
  PAGELINK: "pageLink",
});

export const TXVSREQPGMDIVCD = Object.freeze({
  DATALINE: "C30",
});

export const CPORCD = Object.freeze({
  BIZLINE: "343",
});
